function Header2(props) {
    return (
        <h2 className="text-greydark text-center px-8 py-4">{props.children}</h2>
    )
}

export default Header2